import { render, staticRenderFns } from "./StockTracking.vue?vue&type=template&id=040571b3&scoped=true"
import script from "./StockTracking.vue?vue&type=script&lang=js"
export * from "./StockTracking.vue?vue&type=script&lang=js"
import style0 from "./StockTracking.vue?vue&type=style&index=0&id=040571b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040571b3",
  null
  
)

export default component.exports